class RewardsSlider extends HTMLElement {
  constructor(){
    super();

    this.modal = new theme.Modals('redeem-reward-modal');

    const isFirefoxBrowser = navigator.userAgent.includes('Firefox');
    if (isFirefoxBrowser) this.classList.add('is-ff');

    // Use custom API here...
    // Using sweettooth widget temporarily
    document.addEventListener('sweettooth-ready', () => {
      this.sweetTooth = window.SweetTooth;
      this.sweetTooth.subscribe('customer-ready', () => {
        this.renderElements();
      });
    })
  }

  async renderElements() {
    this.customer = this.sweetTooth.customer;
    if (!this.customer) {
      this.handleError();
      return;
    }

    const products = await this.sweetTooth.fetchPointsProducts();
    if (!products) {
      this.handleError();
      return;
    }

    const variable = products.find(({ exchange_type }) => exchange_type === "variable");
    if (!variable) {
      this.handleError();
      return;
    }

    const {
      id,
      reward,
      variable_points_min: min,
      variable_points_step: step
    } = variable;

    const container = document.createElement('div');
    container.innerHTML = '';

    if (this.customer.points_balance < min) {
      container.innerHTML += `
        <div class="title text-muted">
          You have <strong><span class="rewards-current-balance">${this.customer.points_balance}</span></strong> points to spend on purchases.
          <br/>
          A minimum of <strong>${min}</strong> points is required to redeem for rewards.
        </div>
      `
    } else {
      container.innerHTML += `
        <div class="title text-muted" style="margin-bottom: 1em;">
          You have <span class="rewards-current-balance">${this.customer.points_balance}</span> points to spend.
          <br/>
          ${reward.description}
        </div>
        <div class="text-center" data-info>${min} Society Points for $${Math.trunc(min/step)} off</div>
        <div class="range-slider">
          <input ${this.customer.points_balance < min ? 'disabled' : '' } type="range" min="${min}" max="${this.customer.points_balance > variable.variable_points_max ? variable.variable_points_max : this.customer.points_balance}" step="${step}" value="${min}" aria-label="Points to redeem" style="--min: ${min}; --max: ${min}; --val: ${min}">
        </div>
        <div class="title text-muted" style="margin-bottom: 1em;">
          Minimum redeemable points: ${min}
        </div>
        
        <button ${this.customer.points_balance < min ? 'disabled' : '' } type="button" data-product-id="${id}" data-points="${min}" aria-label="Redeem reward" class="btn btn--full">
          ${this.customer.points_balance < min ? `You need ${min} points!` : 'Spend Points' }
        </button>
      `;
    }

    this.innerHTML = '';
    this.appendChild(container);
    this.classList.add('is-loaded');
    this.initEvents();
  }

  initEvents() {
    const input = this.querySelector('input[type="range"]');
    const info = this.querySelector('[data-info]');
    if (!input || !info) return;

    input.addEventListener('input', (e) => {
      const { step, value } = e.target;
      e.target.style.setProperty('--val', value);
      info.innerHTML = `${value} Society Points for $${Math.trunc(value/step)} off`;

      const parent = e.target.closest('.range-slider');
      const button = parent.nextElementSibling;
      if (button) {
        button.dataset.points = value;
      }
    });

    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', (e) => {
      this.redeemReward(e);
    })
  }

  async redeemReward(e) {
    const self = e.target;
    const productid = +self.dataset.productId;
    const points = +self.dataset.points;
    const customerid = this.customer.id;
    const currentBalanceEl = self.parentElement.querySelector('.rewards-current-balance');
    const accountBalanceEl = document.querySelector('.adrift-points-balance');

    if (!productid || !customerid || !points) {
      this.handleError();
      return;
    }

    // console.log({ productid, customerid, points })
    self.classList.add('btn--loading');
    try {
      const res = await fetch('https://sync.arkhi.com.au/adrift/points', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ customerid, productid, points })
      });
      const data = await res.json();

      if (res.ok && res.status === 200) {
        this.showPopup(data);
        this.hideElement();
        const customerBal = this.customer.points_balance - points;
        if(currentBalanceEl) {
          currentBalanceEl.textContent = customerBal;
        }
        if(accountBalanceEl) {
          accountBalanceEl.textContent = customerBal;
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      self.classList.remove('btn--loading');
    }
  }

  hideElement() {
    const rewards_elem = document.querySelector('rewards-slider > div');
    if (!rewards_elem) return;

    rewards_elem.innerHTML = "Thank you for redeeming!"
  }

  showPopup(data) {
    if (!this.modal) {
      return;
    }

    const container = this.modal.modalContent.querySelector('.js-inject-content');
    if (!container) return;

    const {points_purchase: { fulfilled_reward }} = data;
    container.innerHTML = `
      <h2 class="h3">Your reward is ready</h3>
      <div class="rte">
        <p>Hey ${this.customer.first_name}, you've redeemed ${fulfilled_reward.source_description.replace('Spent', '')} on a ${fulfilled_reward.name}.</p>
        <p>Copy and paste your code below into the discount box at checkout to use it on your order today!</p>
        <pre>${fulfilled_reward.code}</pre>
        <p>If you choose not to use this code today, it has been emailed to you x</p>
        <a href="/checkout" class="btn">Continue to checkout</a>
        <small>Rewards can only be used on purchases of $70.00 or more.</small>
      </div>
    `;

    this.modal.open();
  }

  handleError() {
    this.innerHTML = '';
    this.append('Error loading Reward Slider. Please reload page.');
  }
}

if (!customElements.get('rewards-slider')) {
  customElements.define('rewards-slider', RewardsSlider);
}
